import React from 'react';
import { Row, Button, Col, Spinner } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';

import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import Form from 'react-bootstrap/Form';
import MaterialTable from 'material-table';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withAuthorization } from '../Session';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

import './styles.css';
import queryString from 'query-string';
import ReactExport from 'react-export-excel';

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const pageSizes = [5, 10, 25, 50, 100];
const statusArray =[
    { key: 'COMPLETE', value: 'COMPLETE' },
    { key: 'PENDING', value: 'PENDING' },
    { key: 'CANCELED', value: 'CANCELED' },
    
]
const searchBy = [
    { key: 'Amount', value: 'amount' },
    { key: 'Order ID', value: 'orderId' },
    { key: 'Partner Id', value: 'ProfileUniqeID' },
    { key: 'Created On', value: 'Date' },
    { key: 'Status', value: 'status' }
];


export function MaterialUIPickers(props) {
    if (props.id == 'date-picker-inline1') {
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        var firstDay = date.setDate(date.getDate() - 30);
        //var firstDay = new Date(y, m, 1);
    } else {
        //var firstDay = new Date();
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        var firstDay = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        //var firstDay = date.setDate(date.getDate() -15);
    }
    const [selectedDate, setSelectedDate] = React.useState(firstDay);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        props.setDate(date);
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justifyContent="space-around">
                <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="none"
                    id={props.id}
                    label={props.label}
                    value={selectedDate}
                    onChange={handleDateChange}
                    maxDate={new Date()}
                    autoOk={true}
                    KeyboardButtonProps={{
                        'aria-label': 'change date'
                    }}
                />
            </Grid>
        </MuiPickersUtilsProvider>
    );
}

class GCOrders extends React.Component {
    _isMounted = false;

    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        isLastPage:false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'amount',
        loading: false,
        fromDate: '',
        toDate: this.getFormattedDateTo(new Date()),

        alert: 0,
        alertMessage: '',
        storeTag: '',
        backArrow: false,
        flag: 0,
        data: [],
        reportData:[],
        ShowFlashMessage: false,
        FlashMessage: '',
        MasterGiftCard:this.props.gcard?this.props.gcard.MasterGiftCard:'',
        DownloadReady:false,
    };

    dataArray = [];

    getFormattedDate(date) {
        // date.setDate(date.getDate() -30);
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

    getFormattedDateTo(date) {
        //date.setDate(date.getDate() -15);
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.relaodData();
            
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    
    createReport = async () => {
        if (this._isMounted) {
            this.setState({
                loading: true,
                DownloadReady:false,
            });
        }
        let bodyData = {
            GCSku: this.props.gcard.sku,
            search_key: this.state.search_key?this.state.search_key:this.state.fromDate,
            fromDate:this.state.fromDate,
            toDate:this.state.toDate,
            search_by: this.state.search_by,
            moveTo: false,
            StartAt: [],
            LastDocument: false,
            FirstDocument: false,
            perPage: 10000000,
        };
        
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'giftcards/getMyGiftCards'
         )
            .then((response) => response.json())
            .then((responseData) => {
                if (this._isMounted) {
                    this.setState({
                        reportData: responseData.list,
                        alert: 0,
                        loading: false,
                        DownloadReady:true,
                    });
                }

            })
                
        
            }
    async relaodData() {
        if (this._isMounted) {
            this.setState({
                loading: true,
                DownloadReady:false
            });
        }

        let bodyData = {
            GCSku: this.props.gcard.sku,
            search_key: this.state.search_key?this.state.search_key:this.state.fromDate,
            fromDate:this.state.fromDate,
            toDate:this.state.toDate,
            search_by: this.state.search_by,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };
        //console.log(bodyData)
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'giftcards/getMyGiftCards'
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                //console.log(responseData)
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                if(responseData.list.length>0){
                   
                    
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            isLastPage: responseData.list.length <parseInt(this.state.perPage) ? true:false,
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.list,
                            alert: 0,
                            loading: false
                        });
                    }
                    
                    }else{
                    if (this._isMounted) {
                        this.setState({
                            data:[],
                            isLastPage: true,
                            alert: 0,
                            loading: false
                        });
                    }
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        data: [],
                        loading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.relaodData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            search_by: 'amount',
            moveTo: false,
            StartAt: [],
            pageNumber: 0,
            fromDate:''
        });
        setTimeout(() => {
            this.relaodData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ moveTo: 'Next' });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ moveTo: 'Prev' });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
        this.setState({ search_key: '' }); 
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    
    copyToClipboard = (textToCopy, FlashMessageString) => {
        
        var textField = document.createElement('textarea');
        textField.innerText = textToCopy;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();

        if (this._isMounted) {
            this.setState({
                ShowFlashMessage: true,
                FlashMessage: FlashMessageString
            });
            setTimeout(() => {
                this.setState({ ShowFlashMessage: false, FlashMessage: '' });
            }, 5000);
        }
    };
    
    async checkOrderStatus(OrderDetail) {
        if (this._isMounted) {
            this.setState({
                loading: true
            });
        }
        try {
        let bodyData={
            Order:OrderDetail,
            UpdatedBy: this.props.user.ProfileUniqeID,
            AddedTimeStamp: dateFormatUtil(),
        }
        RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'gift-card/check-order-status'
        )
        .then((response) => response.json())
        .then((responseData) => {
            
            if(responseData && responseData.status){
            OrderDetail.status= responseData.status
            if (this._isMounted) {
                this.setState({
                    loading: false,
                    ShowFlashMessage: true,
                    FlashMessage: responseData.error?responseData.error:responseData.message
                });
                setTimeout(() => {
                    this.setState({
                    ShowFlashMessage:false
                    })
                }, 5000);
            }
        }else{
            if (this._isMounted) {
                this.setState({
                    loading: false,
                    ShowFlashMessage: true,
                    FlashMessage: responseData.error?responseData.error:'Oops something went wrong...'
                });
                setTimeout(() => {
                    this.setState({
                    ShowFlashMessage:false
                    })
                }, 5000);
            }
        }
        })
      } catch (error) {
        if (this._isMounted) {
            this.setState({
                loading: false
            });
        }
    }
        

    }
    
    getLinkAmount(itemAmount) {
        if (itemAmount > 0) {
            return '₹' + parseFloat(itemAmount).toFixed(2);
        } else {
            itemAmount = 0;
            return '₹' + parseFloat(itemAmount).toFixed(2);
        }
    }
    
    getChildTableRow = (dataLinks) => {
        let payment = [];
        if (dataLinks.cards) {
            var cards = dataLinks.cards;
            for (let i = 0; i < cards.length; i++) {
                if (i % 2 == 0) {
                    var classNameString = 'tableRowOdd';
                } else {
                    var classNameString = 'tableRowEven';
                }

                payment.push(
                    <tr key={"gift_card_"+cards[i].cardId} className={classNameString}>
                        <td>Card {i + 1}</td>
                        <td>{this.getLinkAmount(cards[i].amount)}</td>
                        <td>{cards[i].cardNumber}
                        <img className="copy_icon" src={'copy-svgrepo-com.svg'}
                                        onClick={(e) =>
                                            this.copyToClipboard(
                                                cards[i].cardNumber,
                                                'Gift Card Code copied to clipboard'
                                            )
                                        }
                                    />
                        </td>
                        <td className="blur_text">{cards[i].cardPin}
                        {cards[i].cardPin &&<img className="copy_icon" src={'copy-svgrepo-com.svg'}
                                        onClick={(e) =>
                                            this.copyToClipboard(
                                                cards[i].cardPin,
                                                'Gift Card Code copied to clipboard'
                                            )
                                        }
                        />}
                        </td>
                        <td >{cards[i].activationCode}
                        {cards[i].activationCode &&<img className="copy_icon" src={'copy-svgrepo-com.svg'}
                                        onClick={(e) =>
                                            this.copyToClipboard(
                                                cards[i].activationCode,
                                                'Activation Code copied to clipboard'
                                            )
                                        }
                        />}
                        </td>
                        <td >{cards[i].activationUrl}
                        {cards[i].activationUrl &&<img className="copy_icon" src={'copy-svgrepo-com.svg'}
                                        onClick={(e) =>
                                            this.copyToClipboard(
                                                cards[i].activationUrl,
                                                'Activation Url copied to clipboard'
                                            )
                                        }
                        />}
                        </td>

                        <td>{getFormattedDateTime(cards[i].issuanceDate)}</td>
                        <td>{getFormattedDateTime(cards[i].validity)}</td>
                    </tr>
                );
            }
        } 
        return payment;
    };

    getChildRow = (dataLinks) => {
     if(dataLinks.cards){
           dataLinks.cards.forEach(card=>{
            card.orderId = dataLinks.orderId
            card.ProfileUniqeID = dataLinks.ProfileUniqeID
        });
    }
        var orderId = dataLinks.refno;

        let row = [];
        row.push(
            <tr id={"child_"+orderId} key={"child_"+orderId}  className="childtable hiddentable">
                <td colSpan="11" style={{ padding: '0' }}>
                    <table className="table">
                        <thead>
                            <tr className="tableHead">
                                <td>Card #</td>
                                <td>Amount</td>
                                <td>Card Number</td>
                                <td>Card Pin</td>
                                <td>Activation Pin</td>
                                <td>Activation Url</td>
                                <td>Issuance Date</td>
                                <td>Valid Till Date</td>
                                <td><ExcelFile
                            element={
                                <img className="copy_icon" src={'download.png'} />
                            }
                            filename="Gift Cards"
                        >
                            <ExcelSheet
                                data={dataLinks.cards}
                                name="Gift Cards"
                            >
                                <ExcelColumn
                                    label="Order ID"
                                    value="orderId"
                                />
                                <ExcelColumn
                                    label="Partner ID"
                                    value="ProfileUniqeID"
                                />
                                <ExcelColumn
                                    label="Card Number"
                                    value="cardNumber"
                                />
                                <ExcelColumn
                                    label="Card Pin"
                                    value="cardPin"
                                />
                                <ExcelColumn
                                    label="Amount"
                                    value="amount"
                                />
                                <ExcelColumn
                                    label="Created Date"
                                    value="issuanceDate"
                                />
                                <ExcelColumn
                                    label="Validity"
                                    value="validity"
                                />
                            </ExcelSheet>
                        </ExcelFile></td>
                            </tr>
                        </thead>
                        <tbody>{this.getChildTableRow(dataLinks)}</tbody>
                    </table>
                </td>
            </tr>
        );
        return row;
    };
    toggleChildPayments = (orderId) => {
        
        let highlightedItems = document.querySelectorAll('.childtable');
        highlightedItems.forEach((userItem) => {
            userItem.classList.add('hiddentable');
        });

        setTimeout(() => {
            let elem = document.querySelector('#child_' + orderId);
            elem.classList.remove('hiddentable');
        }, 100);
    };


    render() {
        var giftcards = [];
        var giftcardsCoupon = [];
        var dataList = this.state.data;

        var reportData = this.state.reportData;
        var AmazonReportData =[]
        for (let i = 0; i < reportData.length; i++) {
            
            if(reportData[i].status ==='COMPLETE'){
                AmazonReportData.push({
                    refno:reportData[i].refno?reportData[i].refno:'null',
                    sku:reportData[i].GCSku?reportData[i].GCSku:'null',
                    productName:reportData[i].productName,
                    giftOrderId:reportData[i].orderId?reportData[i].orderId:'null',
                    ProfileUniqeID:reportData[i].ProfileUniqeID?reportData[i].ProfileUniqeID:'null',
                    totalamount:reportData[i].amount?parseFloat(reportData[i].amount)*reportData[i].qty:0,
                     discount:reportData[i].discount?parseFloat(reportData[i].discount)+'%':'0%',
                    discountAmount:reportData[i].discountAmount?parseFloat(reportData[i].discountAmount):0,
                   issuanceDate:reportData[i].Date?reportData[i].Date:'null',
                    Comments:reportData[i].Description?reportData[i].Description:'null',
                });
                    
           
            }
            
        }

        for (let i = 0; i < dataList.length; i++) {
            
            let tableRow = '';
            if (i % 2 == 0) {
                var classNameString = 'tableRowOdd';
            } else {
                var classNameString = 'tableRowEven';
            }
            
            if(dataList[i].status ==='COMPLETE'){
               
            var cards = dataList[i].cards;
            if(cards){
            for (let c = 0; c < cards.length; c++) {
            giftcardsCoupon.push({
                giftOrderId:dataList[i].orderId?dataList[i].orderId:'null',
                sku:dataList[i].GCSku?dataList[i].GCSku:'null',
                productName:dataList[i].productName,
                ProfileUniqeID:dataList[i].ProfileUniqeID?dataList[i].ProfileUniqeID:'null',
                Comments:dataList[i].Description?dataList[i].Description:'null',
                cardNumber:cards[c].cardNumber,
                cardPin:cards[c].cardPin,
                amount:cards[c].amount,
                validity:cards[c].validity,
                issuanceDate:cards[c].issuanceDate});
            }
            }
            }
            
            giftcards.push(
                <tr
                key={'table_' + dataList[i].refno}
                    id={'table_' + dataList[i].refno}
                    className={classNameString}
                >
                    <td>
                        {dataList[i].status ==='COMPLETE' ?<p
                                        onClick={(e) =>
                                            this.toggleChildPayments(dataList[i].refno)
                                        }
                                        style={{color:'blue',cursor:'pointer'}}

                        >{dataList[i].orderId}</p>:<p>{dataList[i].orderId}</p>}
                    </td>
                    <td>{dataList[i].GCSku}</td>
                    <td>{dataList[i].productName}</td>
                    
                    <td>{dataList[i].ProfileUniqeID}</td>
                    <td>{this.getLinkAmount(parseFloat(dataList[i].amount)*dataList[i].qty)}</td>
                    <td>{this.getLinkAmount(dataList[i].discount)}%</td>
                    <td>{this.getLinkAmount(dataList[i].discountAmount)}</td>
                    
                    <td>{getFormattedDateTime(dataList[i].Date)}</td>
                    <td>{dataList[i].Description}</td>
                    <td>
                    {dataList[i].status !='CANCELED' && dataList[i].status !='COMPLETE' ?<p
                                        onClick={(e) =>
                                            this.checkOrderStatus(dataList[i])
                                        }
                                        style={{color:'red',cursor:'pointer'}}

                        >{dataList[i].status}  - Check Status</p>:<p className={"ORDER_"+dataList[i].status}>{dataList[i].status}</p>}
                        </td>
                    <td></td>
                </tr>
            );

            giftcards.push(this.getChildRow(dataList[i]));
            
        }

        return (
            <div>
                {this.state.ShowFlashMessage && (
                    <Alert className="FlashMessage" variant="success">
                        {this.state.FlashMessage}
                    </Alert>
                )}

                {this.state.loading && <Spinner animation="border" />}

                {this.state.alert === 1 && (
                    <Row>
                        <Col>
                            <Alert variant="danger">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                <Row style={{ justifyContent: 'right' }}>
                            <Col
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right'
                                }}
                            >
                                <Form.Group
                                    as={Row}
                                    style={{
                                        justifyContent: 'right',
                                        marginRight: '0'
                                    }}
                                >
                                    <select
                                        className="form-control"
                                        style={{ width: 'auto' }}
                                        name="search_by"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_by}
                                    >
                                        {searchBy.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                Search By {search.key}
                                            </option>
                                        ))}
                                    </select>
                                    {this.state.search_by =='status' &&<select
                                        className="form-control"
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        name="search_key"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_key}
                                    >
                                        {statusArray.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                {search.key}
                                            </option>
                                        ))}
                                    </select>}

                                    {this.state.search_by !=='status' && this.state.search_by =='Date' &&<Row style={{ marginLeft: '0px',marginRight: '0px' }}>
                                    <Col>
                                        <MaterialUIPickers
                                id="date-picker-inline1"
                                label="From Date"
                                setDate={(date) => {
                                    this.setState({
                                        search_key: this.getFormattedDate(date)
                                    });
                                }}
                            />
                            </Col>
                            <Col>
                                    <MaterialUIPickers
                                id="date-picker-inline2"
                                label="To Date"
                                setDate={(date) => {
                                    this.setState({
                                        toDate: this.getFormattedDate(date)
                                    });
                                }}
                            />
                            </Col>
                                    </Row>}
                                    {this.state.search_by !=='status' && this.state.search_by !=='Date' &&<Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />}
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                                    {!this.state.DownloadReady ?<Button style={{ marginLeft: '1rem' }} variant="primary" onClick={this.createReport}>
                                    Generate Report
                                </Button>:<ExcelFile
                            element={ <Button style={{ marginLeft: '1rem' }} variant="primary">Download Report </Button>}
                            filename="Amazon Report"
                                >
                            <ExcelSheet
                                data={AmazonReportData}
                                name="Amazon Report"
                            >
                                <ExcelColumn
                                    label="Order Date"
                                    value="issuanceDate"
                                />
                                <ExcelColumn
                                    label="SKU"
                                    value="sku"
                                />
                                <ExcelColumn
                                    label="GC Name"
                                    value="productName"
                                />
                                <ExcelColumn
                                    label="Order ID"
                                    value="giftOrderId"
                                />
                                <ExcelColumn
                                    label="GC Reference Number"
                                    value="refno"
                                />
                                <ExcelColumn
                                    label="Store ID"
                                    value="ProfileUniqeID"
                                />
                                
                                <ExcelColumn
                                    label="Issuance Value"
                                    value="totalamount"
                                />
                                <ExcelColumn
                                    label="Discount"
                                    value="discount"
                                />
                                <ExcelColumn
                                    label="Discount Amount"
                                    value="discountAmount"
                                />

                                <ExcelColumn
                                    label="Comments"
                                    value="Comments"
                                />
                                
                                
                            </ExcelSheet>
                        </ExcelFile>}
                                </Form.Group>
                            </Col>
                        </Row>
                        <table className="table">
                            <thead>
                                <tr className="tableHead">
                                    <td>Order ID</td>
                                    <td>SKU</td>
                                    <td>GC Name</td>
                                    <td>Partner Id</td>
                                    <td>Order Amount</td>
                                    <td>Discount</td>
                                    <td>Discount Amount</td>
                                    
                                    <td>Created Date</td>
                                    <td>Comment</td>
                                    <td>Status</td>
                        <td><ExcelFile
                            element={
                                <img className="copy_icon" src={'download.png'} />
                            }
                            filename='Gift Cards'
                        >
                            <ExcelSheet
                                data={giftcardsCoupon}
                                name="Gift Cards"
                            >
                                <ExcelColumn
                                    label="Order ID"
                                    value="giftOrderId"
                                />
                                <ExcelColumn
                                    label="SKU"
                                    value="sku"
                                />
                                <ExcelColumn
                                    label="GC Name"
                                    value="productName"
                                />
                                <ExcelColumn
                                    label="Partner ID"
                                    value="ProfileUniqeID"
                                />

                                <ExcelColumn
                                    label="Card Number"
                                    value="cardNumber"
                                />
                                <ExcelColumn
                                    label="Card Pin"
                                    value="cardPin"
                                />
                                <ExcelColumn
                                    label="Amount"
                                    value="amount"
                                />
                                <ExcelColumn
                                    label="Created Date"
                                    value="issuanceDate"
                                />
                                <ExcelColumn
                                    label="Validity"
                                    value="validity"
                                />
                                <ExcelColumn
                                    label="Comments"
                                    value="Comments"
                                />
                            </ExcelSheet>
                        </ExcelFile></td>
                                </tr>
                            </thead>
                            <tbody>{giftcards}</tbody>
                        </table>

                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.isLastPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {!this.state.isLastPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                
                
            </div>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(GCOrders);
